export const parentNodeClasses = {
  dropdown: 'dropdown-container',
  control: 'control-container',
  menu: 'menu-container', 
};